// Fit all visible series, including negative values and constant signals.
const getChartYRange = (series) => {
    let minimum = Infinity;
    let maximum = -Infinity;
    for (const { points } of series) {
        for (const track of points) {
            for (const { y } of track) {
                if (!Number.isFinite(y)) continue;
                minimum = Math.min(minimum, y);
                maximum = Math.max(maximum, y);
            }
        }
    }
    if (!Number.isFinite(minimum)) return null;
    const padding = (maximum - minimum) * 0.05 || Math.abs(maximum) * 0.05 || 1;
    return { minimum: minimum - padding, maximum: maximum + padding };
};

export default getChartYRange;
